import { executeRequest, Request } from '@jfs/network'
import { fromDateTime, toDateTime } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getType } from './bulkOnboardingFileDownload'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return {
    response: response,
    page: {
      size: response?.data?.size,
      totalElements: response?.data?.totalElements,
      totalPages: response?.data?.totalPages,
      number: response?.data?.totalElements === 0 ? 1 : response?.data?.pageNo,
    },
  }
}

const uploadedFileHistory = (tokens: any, type: string, page: number, size: number, selectedDateInfo: any) => {
  const request: Request<{}> = {
    apiPath: getUrl(APIEndPoints.bulkOnboardUploadList),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    body: {
      type: getType(type),
      pageNo: page,
      size: size,
      toDate: toDateTime(selectedDateInfo.toDate),
      fromDate: fromDateTime(selectedDateInfo.fromDate),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { uploadedFileHistory }
